 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		39: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		39: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"8":"app-components-Workflow-WorkflowContainer","9":"app-components-bibs-BibPage-BibPageContainer","10":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","11":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","12":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","13":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","14":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","15":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","16":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","17":"app-components-bibs-subpages-CommentPage-CommentPageContainer","18":"app-components-bibs-subpages-MarcPage-MarcPageContainer","19":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","20":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","21":"app-components-bibs-subpages-VideoPage-VideoPageContainer","22":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","23":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","24":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","25":"app-components-borrowing-fines-Fines-FinesContainer","26":"app-components-borrowing-holds-Holds-HoldsContainer","27":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","28":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","29":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","30":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","31":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","32":"app-components-events-EventsSearchPage-EventsSearchPageContainer","33":"app-components-search-Search-SearchContainer","34":"app-components-search-SearchPrintList-SearchPrintListContainer","35":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","36":"app-components-shelves-Shelf-ShelfContainer","37":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","38":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"de530a92059fecc16c34","1":"0224b620421e809117f6","2":"3fb82729c0012c8650d1","3":"acc869209aad4cf8c695","4":"8d4cab1b59f3c0c41e14","5":"4cc2d0174b3226e2e0d0","6":"6fceb4f6503e52faebf5","7":"123b2c0d2f07b3568384","8":"6bea046c33b04377c9e9","9":"7b846635d689dc55fbd6","10":"6b661e7a7a66f2677a4a","11":"4e223f15ed9ef301a198","12":"e93ad8a80c952506597c","13":"b085714c7f6dfa593ef4","14":"f4570f0e1dc840738125","15":"d3ae970c90dbf439f95a","16":"3548b4787a70d7aaab0e","17":"f195df46cd0516775623","18":"33ff6baf481f55985046","19":"a10dfb618db451fb3ba0","20":"149db3bda44a07ce039e","21":"b9e863939b7e19f8e779","22":"afa68e5f4080adb713af","23":"440809b5142d4c8063f1","24":"cc0dfcd0debefe3e0f2d","25":"841c52a71e8c16a7bd30","26":"e3cdeb46ad41403d20e9","27":"8c6ee7e4c0fb5d462d67","28":"7cc73eaee1047bde730f","29":"111b4eecca178e601e9d","30":"3cbf22d7eaeacd1d59af","31":"f262151971ef8ebaec9e","32":"011d81176dbd506d3f24","33":"1400e9d22f1e51c643a9","34":"6979a50473bbca2b36fd","35":"27237d3ec86c8f368e13","36":"ec4613fc9593c4bd6551","37":"e19aae1d4dd9ebaea099","38":"ed9067703e925f49c3be","41":"9cb6a6c1add3c9ade3cc","42":"916fda8f765d4823a7dd","43":"f04c1ace56f8378cb6d4","44":"269e0a753ff5f6c96b23","45":"57e514bf96de1b6997aa","46":"3bdfc013baabbf4edf83","47":"ffe74ab4c4a2abfc63cc","48":"9b0f9258ae4e2f1181e6","49":"af0934c914ae7cd2f735"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"8":"app-components-Workflow-WorkflowContainer","9":"app-components-bibs-BibPage-BibPageContainer","10":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","11":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","12":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","13":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","14":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","15":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","16":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","17":"app-components-bibs-subpages-CommentPage-CommentPageContainer","18":"app-components-bibs-subpages-MarcPage-MarcPageContainer","19":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","20":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","21":"app-components-bibs-subpages-VideoPage-VideoPageContainer","22":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","23":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","24":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","25":"app-components-borrowing-fines-Fines-FinesContainer","26":"app-components-borrowing-holds-Holds-HoldsContainer","27":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","28":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","29":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","30":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","31":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","32":"app-components-events-EventsSearchPage-EventsSearchPageContainer","33":"app-components-search-Search-SearchContainer","34":"app-components-search-SearchPrintList-SearchPrintListContainer","35":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","36":"app-components-shelves-Shelf-ShelfContainer","37":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","38":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"de530a92059fecc16c34","1":"0224b620421e809117f6","2":"3fb82729c0012c8650d1","3":"acc869209aad4cf8c695","4":"8d4cab1b59f3c0c41e14","5":"4cc2d0174b3226e2e0d0","6":"6fceb4f6503e52faebf5","7":"123b2c0d2f07b3568384","8":"6bea046c33b04377c9e9","9":"7b846635d689dc55fbd6","10":"6b661e7a7a66f2677a4a","11":"4e223f15ed9ef301a198","12":"e93ad8a80c952506597c","13":"b085714c7f6dfa593ef4","14":"f4570f0e1dc840738125","15":"d3ae970c90dbf439f95a","16":"3548b4787a70d7aaab0e","17":"f195df46cd0516775623","18":"33ff6baf481f55985046","19":"a10dfb618db451fb3ba0","20":"149db3bda44a07ce039e","21":"b9e863939b7e19f8e779","22":"afa68e5f4080adb713af","23":"440809b5142d4c8063f1","24":"cc0dfcd0debefe3e0f2d","25":"841c52a71e8c16a7bd30","26":"e3cdeb46ad41403d20e9","27":"8c6ee7e4c0fb5d462d67","28":"7cc73eaee1047bde730f","29":"111b4eecca178e601e9d","30":"3cbf22d7eaeacd1d59af","31":"f262151971ef8ebaec9e","32":"011d81176dbd506d3f24","33":"1400e9d22f1e51c643a9","34":"6979a50473bbca2b36fd","35":"27237d3ec86c8f368e13","36":"ec4613fc9593c4bd6551","37":"e19aae1d4dd9ebaea099","38":"ed9067703e925f49c3be","41":"9cb6a6c1add3c9ade3cc","42":"916fda8f765d4823a7dd","43":"f04c1ace56f8378cb6d4","44":"269e0a753ff5f6c96b23","45":"57e514bf96de1b6997aa","46":"3bdfc013baabbf4edf83","47":"ffe74ab4c4a2abfc63cc","48":"9b0f9258ae4e2f1181e6","49":"af0934c914ae7cd2f735"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2214);
